import * as B from '@blueprintjs/core';
import React from 'react';

import cs from './styles.module.scss';

interface Props {
  isPlaying: boolean;
  canPlay: boolean;
  onTogglePlaying: () => void;
  canStepBack: boolean;
  canStepForward: boolean;
  onStep: (offset: number) => void;
  dateLabel: string;
  positionLabel: string;
}

const PlaybackControls: React.FunctionComponent<Props> = ({
  isPlaying,
  canPlay,
  onTogglePlaying,
  canStepBack,
  canStepForward,
  onStep,
  dateLabel,
  positionLabel,
}) => (
  <div className={cs.controls}>
    <button
      type="button"
      className={cs.play}
      aria-label={isPlaying ? 'Pause' : 'Play'}
      disabled={!canPlay}
      onClick={onTogglePlaying}
    >
      <B.Icon icon={isPlaying ? 'pause' : 'play'} size={18} />
    </button>
    <B.Button
      minimal
      icon="chevron-left"
      aria-label="Previous scene"
      disabled={!canStepBack}
      onClick={() => onStep(-1)}
    />
    <B.Button
      minimal
      icon="chevron-right"
      aria-label="Next scene"
      disabled={!canStepForward}
      onClick={() => onStep(1)}
    />
    <div className={cs.label}>
      <span className={cs.date}>{dateLabel}</span>
      <span className={cs.position}>{positionLabel}</span>
    </div>
  </div>
);

export default PlaybackControls;
